import React, {useState} from "react";
import {Modal} from 'antd';
import CommentList from "../../../Comment/CommentList";
import CommentForm from "../../../Form/Comment/CommentForm";

const CommentModal = ({visible, onCancel, disableStatus, documentId, user, allowComments = true}) => {
    const [refreshKey, setRefreshKey] = useState(0);

    const handleCommentSubmit = () => {
        setRefreshKey(prev => prev + 1); // triggers re-render of CommentList
    };

    return (
        <Modal
            title="Comments"
            open={visible}
            onCancel={onCancel}
            closable={true}
            footer={null}
            className="Modal-header"
            centered={false}
            width={650}>
            <CommentList key={refreshKey} documentId={documentId} user={user} disableStatus={disableStatus}/>
            {allowComments && (
                <CommentForm documentId={documentId} user={user} onSubmit={handleCommentSubmit}/>
            )}

        </Modal>
    )
}
export default CommentModal;